import React, { Component } from "react";
import { IconChevronRight, IconChevronDown } from 'Icons'
import "./ChapterRibbon.css";
import InfoButton from "./InfoButton";
import styled from "styled-components";
import {rgba} from 'polished';
import MediaQuery from "react-responsive";

const StyledChapterRibbon = styled.div`
&& {
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 0;
  background: #fff;
  border: none;
  margin: 0 0 0.3em;
  float: none;
  border-radius: 10px;
  width: 100%;
  position: relative;
  font-weight: 500;
  cursor: pointer;
  transition: all .3s ease-in;
  padding: 10px 8px;
  background-color: ${({ theme }) => rgba(theme.color4, 0.5)};
  ${'' /* color: ${({ theme }) => theme.button.primary.text} */}
}
`;

const StyledBoxWrapper = styled.div`
  padding: 0 5px;
  display: flex;

`;

class ChapterRibbon extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { chapter, open,noOfPage,videoDur,maxScore } = this.props.chapter;

    return (
      <StyledChapterRibbon onClick={this.props.expandChapter} >
        {/* <div
          className="box-tools "
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        > */}
          {/* <div > */}
            {/* <Glyphicon glyph={open ? "minus" : "plus"} style={{ top: "3px" }} /> */}
            {/* <span style={{ marginLeft: "10px", fontSize: "20px" }}>{chapter}</span>
          </div> */}
          <MediaQuery maxDeviceWidth={767}>
          <div className="ribbon-chapter-title">{chapter}</div>
         </MediaQuery>

          <MediaQuery minDeviceWidth={768}>
          <div className="ribbon-chapter-title">{chapter}</div>
         </MediaQuery>
          {/* <div style={{ display: "flex", flexDirection: "row" }}> */}
          <StyledBoxWrapper>
            <InfoButton
              label="pages"
              value={noOfPage}
              color={"#29829d"}
              //icon={faFilePdf}
            ></InfoButton>
            <InfoButton
              label="minutes"
              value={videoDur}
              color={"#00C49F"}
              //icon={faVideo}
            ></InfoButton>
            <InfoButton
              label="credits"
              value={maxScore}
              color={"#FFBB28"}
              //icon={faVideo}
            ></InfoButton>
            </StyledBoxWrapper>
          {/* </div> */}
        {/* </div> */}
      </StyledChapterRibbon>
    );
  }
}

export default ChapterRibbon;
